import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSignupScreen from './AbstractStartSignupScreen';

export default class GenericStartSignupScreen extends AbstractStartSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-signup';

  public predicate(): boolean {
    return this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.genericSignup)
      && this.sessionInfo.value.emailCheckCode === null;
  }
}
